import React, { useState } from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from 'contexts/auth';
import { AppProvider } from 'contexts/app';
import { GlobalDataProvider } from 'contexts/global-data';
import AppComponent from 'App';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

const App = () => {
  const [app, setApp] = useState(null);
  return (
    <AppProvider value={{ app, setApp }}>
      <AuthProvider>
        <GlobalDataProvider>
          <BrowserRouter basename={app?.base_url || '/'}>
            <AppComponent />
          </BrowserRouter>
        </GlobalDataProvider>
      </AuthProvider>
    </AppProvider>
  );
};

root.render(<App />);
